





//same hight script start


/*

 Name: jQuery sameHeight 1.4.0
 Author: giorgio.beggiora@gmail.com

 requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
 https://gist.github.com/paulirish/1579671

 Optional dependency: CSS-Element-Queries
 http://marcj.github.io/css-element-queries/

 This plugin sets all the matched elements' height to the highest one,
 waiting for images in them to have their height setted (i.e. when they're loaded).
 It's compatible with elements in a container with the css property column-count
 greater than 1.

 Options:

 - compact (boolean) [default = false] : each row will have its own height.

 - responsive (boolean) [default = true] : if true, the max height depends
 from the elements' content, from css otherwise.

 - target: if an element is given, the height will be its one.

 - debounce: debounce in milliseconds, rounded by requestAnimationFrame.

 - observe (window/DOM element) [default = window]: elements which size changes
   must be detected.

 - columnCount (number/string) [default = 1]: closest ancestor's CSS column-count
   property's value ('auto' is not supported).
   If set to 'calc', each time the resize event is triggered the DOM will be traversed
   upward until an element with a column-count value greater than 1 will be found,
   so it's better to avoid it and explicitly set a number.

Returns:

An instance of the observer with the stop() method to stop listening the resize event (similar to the jQuery's off() method).

 */

if (!Number.isFinite) Number.isFinite = function(value) {
	return typeof value === 'number' && isFinite(value);
}

if (!Number.isInteger) Number.isInteger = function(value) {
	return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

;(function() {

	if (!window.requestAnimationFrame) {
		window.requestAnimationFrame = window.mozRequestAnimationFrame
	    || window.webkitRequestAnimationFrame
	    || window.msRequestAnimationFrame
	    || function(f){return setTimeout(f, 1000/60)}
	}

	if (!window.cancelAnimationFrame) {
		window.cancelAnimationFrame = window.mozCancelAnimationFrame
		|| function(requestID){clearTimeout(requestID)}
	}

}());

(function ( $ ) {

	const win = this;
	var eventResizeHandler = null;

	var elementResizeHandlers = [];
	var windowObserverHandlers = null;
	var windowObserverHandlersLen = 0;
	var windowObserverHandlersAI = 0;

	var rAFTimeoutHandlers = {};
	var rAFTimeoutHandlersNextId = 0;
	var windowObserverHandlerId = 0;

	function setRAFTimeout(callback, ms) {

		var id, h, now = Date.now();
		if (arguments.length > 2) {
			id = arguments[2];
			h = rAFTimeoutHandlers[id];
		} else {
			id = rAFTimeoutHandlersNextId++ ;
			h = { id: id, start: now };
			rAFTimeoutHandlers[id] = h;
		}

		if ( h ) {
			if ( now - h.start < ms ) {
				requestAnimationFrame(setRAFTimeout.bind(win, callback, ms, id));
			} else {
				delete rAFTimeoutHandlers[id];
				callback();
			}
		}

		return id;
	}

	function clearRAFTimeout (id) {
		delete rAFTimeoutHandlers[id];
	}

	function sameHeightObserver (options) {

		this.$el = options.$el;
		this.settings = options.settings;

		this.debounceHandler = null; // handler del debouncer
		this.observerHandler = null; // handler dell'observer
		var observeMethod = options.observeMethod;

		if (observeMethod === 'Window') {
			this.windowObserverHandlerId = windowObserverHandlerId;
		}

		this.debouncedResize = debouncedResize.bind(this);

		this.stop = function () {
			var clearHandler = function () {} ;
			switch (observeMethod) {
				case 'Window':
					delete windowObserverHandlers[this.windowObserverHandlerId];
					windowObserverHandlersLen -= 1;
				break;
				case 'ResizeObserver':
					this.observerHandler.disconnect();
				break;
				case 'ResizeSensor':
					this.observerHandler.detach();
				break;
				case 'requestAnimationFrame':
					clearRAFTimeout(this.observerHandler);
				break;
			}
		}

	}

	function debouncedResize() {
		if (this === win) {
			for (id in windowObserverHandlers) {
				var instance = windowObserverHandlers[id];
				clearRAFTimeout(instance.debounceHandler);
				instance.debounceHandler = setRAFTimeout(doTheMagic.bind(instance), instance.settings.debounce);
			}
		} else {
			var instance = this;
			clearRAFTimeout(instance.debounceHandler);
			instance.debounceHandler = setRAFTimeout(doTheMagic.bind(instance), instance.settings.debounce);
		}
	}

	function doTheMagic () {

		var $el = this.$el;
		var settings = this.settings;

		// - Check if asynchronous elements have an height...
		var images = $el.find('img, input[type="image"]').toArray();
		var allImagesHaveHeight = images.every(function(img){
			return !! ( img.complete || img.height || parseInt(getComputedStyle(img).height) );
		});

		// ...If not, continue but schedule another loop.
		if (!allImagesHaveHeight) {
			clearRAFTimeout(this.debounceHandler);
			this.debounceHandler = setRAFTimeout(this.debouncedResize, settings.debounce);
		}

		// - Check if target exists...
		var $target = $(settings.target)

		// ...If yes, use its height, end this loop and schedule another one.
		if($target.length){
			$el.height($target.height());
			clearRAFTimeout(this.debounceHandler);
			this.debounceHandler = setRAFTimeout(this.debouncedResize, settings.debounce);
			return;
		}

		// - Group elements per row
		var groupData = null;

		if (settings.compact) {
			var cssColumns = 1;
			if (typeof settings.columnCount === 'number') {
				cssColumns = settings.columnCount;
			} else if (settings.columnCount === 'calc') {
				var up = $el.get(0).parentNode;
				var columnCount = '';
				do {
					columnCount = Number(getComputedStyle(up).columnCount);
					if (Number.isInteger(columnCount) && columnCount > 1) {
						cssColumns = columnCount;
						break;
					}
					up = up.parentNode;
				} while (up.parentNode);
			}
			groupData = cssColumns > 1 ? groupCompactColumns($el, cssColumns) : groupCompact($el);
		} else {
			groupData = group($el);
		}

		// - Calculate heights
		calcHeights($el, groupData, settings);

	} // end doTheMagic()

	function group ($el) {
		var el_length = $el.length;
		var grouped = [];
		var cols = el_length;
		var rows = 1;
		grouped[0] = [];
		for (var i = 0; i < el_length; i++) {
			grouped[0].push($el.get(i));
		}
		return {grouped: grouped, rows: rows, cols: cols};
	}

	function groupCompact ($el) {
		var el_length = $el.length;
		var grouped = [];
		var y = null;
		for(var cols = 0; cols < el_length; cols++){
			var offset = $el.eq(cols).offset();
			var offsetTop = offset.top;
			if(y !== offsetTop){
				if(y === null){
					y = offsetTop;
				}else{
					break;
				}
			}
		}
		rows = Math.ceil(el_length / cols);
		for(i = 0; i < el_length; i++){
			r = Math.floor(i / cols);
			c = i % cols;
			if(typeof grouped[r] === 'undefined'){
				grouped[r] = [];
			}
			grouped[r].push($el.get(i));
		}
		return {grouped: grouped, rows: rows, cols: cols};
	}

	function groupCompactColumns ($el, cols) {
		var el_length = $el.length;
		var grouped = [];
		var rows = Math.ceil(el_length / cols);
		for(var i = 0; i < el_length; i++){
			var r = i % rows;
			var c = Math.floor(i / rows);
			if(typeof grouped[r] === 'undefined'){
				grouped[r] = [];
			}
			grouped[r].push($el.get(i));
		}
		return {grouped: grouped, rows: rows, cols: cols};
	}

	function calcHeights ($el, groupData, settings) {
		var grouped = groupData.grouped;
		var rows = groupData.rows;
		for(var r = 0; r < rows; r++){
			var maxHeight = 0;
			var g = grouped[r], gl = g.length;
			for(var c = 0; c < gl; c++){
				var item = g[c], $item = $(item);
				if(settings.responsive){
					item.style.height = 'auto';
				}
				maxHeight = Math.max(maxHeight, $item.height());
			}
			$(g).height(maxHeight);
		}
	}

	function sameHeight ( options ) {
		var settings = $.extend({
			compact: false,
			responsive: true,
			target: null,
			observe: window,
			debounce: 1,
			columnCount: 1
		}, options );

		if ($.isNumeric(settings.debounce)){
			settings.debounce = Number(settings.debounce);
			if (settings.debounce < 1) settings.debounce = 1;
		} else {
			settings.debounce = 1;
		}

		if ($.isNumeric(settings.columnCount)) {
			settings.columnCount = Number(settings.columnCount);
			if (settings.columnCount < 1) settings.columnCount = 1;
		} else {
			if (settings.columnCount !== 'calc') settings.columnCount = 1;
		}

		var $el = $(this);
		var newInstanceOptions = {
			$el: $el,
			settings: settings
		};

		var observeWhat = '';
		var observeType = Object.prototype.toString.call( settings.observe );

		if ( observeType === '[object String]' ) {
			observeWhat = 'query';
		} if ( observeType === '[object Window]' ) {
			observeWhat = 'window';
		} else if ( observeType === '[object HTMLCollection]' ) {
			observeWhat = 'element';
		} else if ( observeType.indexOf('[object HTML') === 0 ) {
			observeWhat = 'element';
		}

		var observeMethod = '';
		if (observeWhat === 'window') {
			observeMethod = 'Window';
		} else  if(observeWhat) {
			if ('ResizeObserver' in window) {
				observeMethod = 'ResizeObserver';
			} else if ('ResizeSensor' in window) {
				observeMethod = 'ResizeSensor';
			} else {
				observeMethod = 'requestAnimationFrame';
			}
		}

		newInstanceOptions.observeMethod = observeMethod;
		var newInstance = new sameHeightObserver(newInstanceOptions);

		switch (observeMethod) {
			case 'Window':
				if (windowObserverHandlers === null) {
					windowObserverHandlers = {};
					var $win = $(window);
					$win.on('resize', debouncedResize);
					$win.on('load', debouncedResize);
				}
				windowObserverHandlerId = windowObserverHandlersAI++;
				windowObserverHandlers[windowObserverHandlerId] = newInstance;
				windowObserverHandlersLen += 1;
			break;
			case 'ResizeObserver':
				var ro = new ResizeObserver(newInstance.debouncedResize);
				ro.observe(settings.observe);
				newInstance.observerHandler = ro;
			break;
			case 'ResizeSensor':
				var rs = new ResizeSensor(settings.observe, newInstance.debouncedResize);
				newInstance.observerHandler = rs;
			break;
			case 'requestAnimationFrame':
				var oldw = [], oldh = [];
				(function resizeLoop(instance){
					var neww = [], newh = [];
					var settings = newInstance.settings;
					newInstance.$el.each(function(i, element){
						var $element = $(element);
						neww.push($element.width());
						newh.push($element.height());
					});
					var i = neww.length;
					while(i--){
						if( neww[i] !== oldw[i] || newh[i] !== oldh[i] ){
							oldw = neww;
							oldh = newh;
							newInstance.debouncedResize();
							break;
						}
					}
					newInstance.observerHandler = setRAFTimeout(resizeLoop, settings.debounce);
				})();
			break;
		}

		newInstance.debouncedResize();

		// return instance controller

		return newInstance;

	} // end sameHeight()

	$.fn.sameHeight = sameHeight;

}( jQuery_T4NT ));

//same hight script end

//switch script start
/**
 * LC Switch - superlight pure javascript plugin improving forms look and functionality
 * @version: 2.0.5
 * @author: Luca Montanari (LCweb)
 * @website: https://lcweb.it
 * Licensed under the MIT license
*/

(function($){
	"use strict";
	if(typeof(Element.prototype.lc_switch) != 'undefined') {return false;} // prevent multiple script inits
	
    // flag used to bypass checks
    let forced_action = false;
    
    
    // default options
    const def_options = {
        on_txt      : 'ON',
        off_txt     : 'OFF',
        on_color    : false,
        compact_mode: false,
    };
    
    
    let style_appended = false;
    const append_style = () => {
        if(style_appended) {
            return true;    
        }
        style_appended = true;
        
        const css = `
.lcs_wrap,
.lcs_wrap * {
    user-select: none;
}
.lcs_wrap {
	display: inline-block;	
	direction: ltr;
	height: 28px;
    width: 73px;
    vertical-align: middle;
}
.lcs_wrap input {
	display: none !important;	
}
.lcs_switch {
	display: inline-block;	
	position: relative;
	width: 100%;
	height: 100%;
	border-radius: 30px;
	background: #ddd;
	overflow: hidden;
	cursor: pointer;
	transition: all .2s ease-in-out; 
}
.lcs_cursor {
	display: inline-block;
	position: absolute;
	top: 50%;	
    margin-top: -11px;
	width: 22px;
	height: 22px;
	border-radius: 100%;
	background: #fff;
	box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .2), 0 3px 4px 0 rgba(0, 0, 0, .1);
	z-index: 10;
	transition: all .2s linear; 
}
.lcs_label {
	font-family: "Trebuchet MS", Helvetica, sans-serif;
    font-size: 12px;
	letter-spacing: 1px;
	line-height: 18px;
	color: #fff;
	font-weight: bold;
	position: absolute;
	width: 33px;
	top: 5px;
	overflow: hidden;
	text-align: center;
	opacity: 0;
    text-shadow: 0 0 2px rgba(0,0,0, .1);
	transition: all .2s ease-in-out .1s;   
}
.lcs_label.lcs_label_on {
	left: -70px;
	z-index: 6;	
}
.lcs_label.lcs_label_off {
	right: -70px;
	z-index: 5;	
}
.lcs_switch.lcs_on {
	background: #75b936;
}
.lcs_switch.lcs_on .lcs_cursor {
	left: 48px;
}
.lcs_switch.lcs_on .lcs_label_on {
	left: 10px;	
	opacity: 1;
}
.lcs_switch.lcs_off {
	background: #b2b2b2;
	box-shadow: 0px 0px 2px #a4a4a4 inset; 	
}
.lcs_switch.lcs_off .lcs_cursor {
	left: 3px;
}
.lcs_switch.lcs_off .lcs_label_off {
	right: 10px;
	opacity: 1;	
}
.lcs_switch.lcs_disabled {
	opacity: 0.65;
	cursor: default;
}
.lcs_compact {
    height: 22px;
    width: 47px;
}
.lcs_compact .lcs_label {
    display: none;
}
.lcs_compact .lcs_cursor {
	margin-top: -8px;
	width: 16px;
	height: 16px;
}
.lcs_compact .lcs_switch.lcs_on .lcs_cursor {
	left: 28px;
}`;
        
        if('adoptedStyleSheets' in document) {
            const sheet = new CSSStyleSheet();
            sheet.replaceSync(css);
            document.adoptedStyleSheets = [...document.adoptedStyleSheets, sheet];
        } 
        else {
            const style = document.createElement('style');
            style.textContent = css;
            document.head.appendChild(style);
        }
    };
    
    
    
    // construct
	window.lc_switch = function(selector, options) {

        // options merge
        options = (typeof(options) != 'object') ? def_options : Object.assign({}, def_options, options);
        
        // init
        maybe_querySelectorAll(selector).forEach(function(el) {
            if(
                el.tagName != 'INPUT' ||
                (el.tagName == 'INPUT' && (el.getAttribute('type') != 'checkbox' && el.getAttribute('type') != 'radio'))
            ) {
                return;    
            }

            // do not initialize twice
            if(el.parentNode.classList.length && el.parentNode.classList.contains('lcs_wrap')) {
                return;    
            }

            // labels structure
            const on_label 	= (options.on_txt) ? '<div class="lcs_label lcs_label_on">'+ options.on_txt +'</div>' : '',
                  off_label = (options.off_txt) ? '<div class="lcs_label lcs_label_off">'+ options.off_txt +'</div>' : '';

 
            // default states
            let classes = 'lcs_'+ el.getAttribute('type');
                
            classes += (el.checked) ? ' lcs_on' : ' lcs_off'; 
            
            if(el.disabled) {
                classes += ' lcs_disabled';
            } 
            
            
            // enabled and apply custom color?
            const custom_style = (options.on_color && el.checked) ? 'style="background: '+ options.on_color +';"' : '',
                  custom_on_col_attr = (options.on_color) ? 'data-on-color="'+ options.on_color +'"' : '';
            

            // wrap and append
            const wrapper = document.createElement('div');
            
            wrapper.classList.add('lcs_wrap');
            wrapper.innerHTML = 
            '<div class="lcs_switch '+ classes +'" '+ custom_on_col_attr +' '+ custom_style +'>' +
                '<div class="lcs_cursor"></div>' +
                on_label + off_label +
            '</div>';
            
            
            // compact mode?
            if(options.compact_mode) {
                wrapper.classList.add('lcs_compact');    
            }
            
            el.parentNode.insertBefore(wrapper, el);
            wrapper.appendChild(el);
            
            
            // handlers
            wrapper.querySelector('.lcs_switch').addEventListener('click', (e) => {
                const target = (e.target.classList.contains('lcs_switch')) ? e.target : recursive_parent(e.target, '.lcs_switch');
                
                if(!target.classList.contains('lcs_disabled')) {
                    lcs_toggle(el);
                }
            });
            el.addEventListener('change', (e) => {
                lcs_update(el)
            });
            
            // improve compatibility with systems placing checkboxes into the LABEL tag
            if(el.closest('label') !== null) {
                el.closest('label').addEventListener('click', (e) => {
                    e.preventDefault();
                });
            }
        });
        
        append_style();
    };
    
    
    
    // destruct
	window.lcs_destroy = function(selector) {
        maybe_querySelectorAll(selector).forEach(function(el) {
            if(!is_valid_el(el)) {
                return;    
            }
            
            el.parentNode.replaceWith(el);
        });                
    };
    
    
    
    // set to ON
	window.lcs_on = function(selector) {
        maybe_querySelectorAll(selector).forEach(function(el) {
            if(!is_valid_el(el) || (el.checked && !forced_action)) {
                return;    
            }
               
            // if radio - disable other ones 
            if(el.getAttribute('type') == 'radio') {
                lcs_off(recursive_parent(el, 'form').querySelectorAll('input[name="'+ el.getAttribute('name') +'"]'), true);
            }
            
            // enable
            el.checked = true;
            
            const wrap = el.previousElementSibling;
            wrap.classList.add('lcs_on');
            wrap.classList.remove('lcs_off');
            
            if(wrap.getAttribute('data-on-color')) {
                wrap.style.background = wrap.getAttribute('data-on-color');        
            }
            
            // trigger events
            if(!forced_action) {
                const lcsOnEvent = new Event("lcs-on", {bubbles:true}),
                      lcsStatusChangeEvent = new Event('lcs-statuschange', {bubbles:true});

                el.dispatchEvent(lcsOnEvent);
                el.dispatchEvent(lcsStatusChangeEvent);
            }
        });                
    };
    
    
    
    // set to OFF
	window.lcs_off = function(selector, forced_by_lcsOn) {
        maybe_querySelectorAll(selector).forEach(function(el) {
            if(!is_valid_el(el) || (!el.checked && !forced_action)) {
                return;    
            }
               
            // if radio - allows only if forced by lcs_on
            if(el.getAttribute('type') == 'radio' && !forced_by_lcsOn && !forced_action) {
                return;    
            }
            
            // disable
            el.checked = false;
            
            const wrap = el.previousElementSibling;
            wrap.classList.add('lcs_off');
            wrap.classList.remove('lcs_on');
            
            if(wrap.getAttribute('data-on-color')) {
                wrap.style.background = null;    
            }
            
            // trigger events
            if(!forced_action) {
                const lcsOffEvent = new Event("lcs-off", {bubbles:true}),
                      lcsStatusChangeEvent = new Event('lcs-statuschange', {bubbles:true});

                el.dispatchEvent(lcsOffEvent);
                el.dispatchEvent(lcsStatusChangeEvent);
            }
        });                
    };
    
    
    
    // toggle check status
    window.lcs_toggle = function(selector) {
        maybe_querySelectorAll(selector).forEach(function(el) {
            if(!is_valid_el(el)) {
                return;    
            }
               
            // if radio - allows only if not checked
            if(el.getAttribute('type') == 'radio' && el.checked) {
                return;    
            }
            
            (el.checked) ? lcs_off(el) : lcs_on(el);
        });                
    };
    
    
    
    // DISABLE field
	window.lcs_disable = function(selector) {
        maybe_querySelectorAll(selector).forEach(function(el) {
            if(!is_valid_el(el) || (el.disabled && !forced_action)) {
                return;    
            }
            
            // disable
            el.disabled = true;
            el.previousElementSibling.classList.add('lcs_disabled');

            // trigger events
            const lcsDisabledEvent = new Event("lcs-disabled", {bubbles:true}),
                  lcsStatusChangeEvent = new Event('lcs-statuschange', {bubbles:true});
            
            el.dispatchEvent(lcsDisabledEvent);
            el.dispatchEvent(lcsStatusChangeEvent);
        });                
    };
    
    
    
    // ENABLE field
	window.lcs_enable = function(selector) {
        maybe_querySelectorAll(selector).forEach(function(el) {
            if(!is_valid_el(el) || (!el.disabled && !forced_action)) {
                return;    
            }
            
            // disable
            el.disabled = false;
            el.previousElementSibling.classList.remove('lcs_disabled');

            // trigger events
            const lcsEnabledEvent = new Event("lcs-enabled", {bubbles:true}),
                  lcsStatusChangeEvent = new Event('lcs-statuschange', {bubbles:true});
            
            el.dispatchEvent(lcsEnabledEvent);
            el.dispatchEvent(lcsStatusChangeEvent);
        });                
    };
    
    
    
    // UPDATE LCS statuses retrieving data from field
	window.lcs_update = function(selector) {
        maybe_querySelectorAll(selector).forEach(function(el) {
            if(!is_valid_el(el)) {
                return;    
            }
            
            forced_action = true;
            
            (el.checked) ? lcs_on(el) : lcs_off(el);
            (el.disabled) ? lcs_disable(el) : lcs_enable(el);
            
            forced_action = false;
        });                
    };
    

    
    
    ////////////////////////////////////////////////////////////
    
    
    
    // UTILITIES
    
    // sanitize "selector" parameter allowing both strings and DOM objects
    const maybe_querySelectorAll = (selector) => {
             
        if(typeof(selector) != 'string') {
            if(selector instanceof Element) { // JS or jQuery 
                return [selector];
            }
            else {
                let to_return = [];
                
                for(const obj of selector) {
                    if(obj instanceof Element) {
                        to_return.push(obj);    
                    }
                }
                return to_return;
            }
        }
        
        // clean problematic selectors
        (selector.match(/(#[0-9][^\s:,]*)/g) || []).forEach(function(n) {
            selector = selector.replace(n, '[id="' + n.replace("#", "") + '"]');
        });
        
        return document.querySelectorAll(selector);
    };
    
    
    // know whether an element is a valid input and initialized with LC switch (returns bool)
    const is_valid_el = (el) => {
        if(
            el.tagName != 'INPUT' ||
            (el.tagName == 'INPUT' && (el.getAttribute('type') != 'checkbox' && el.getAttribute('type') != 'radio'))
        ) {
            return false;    
        }

        if(!el.parentNode.classList.length || (el.parentNode.classList.length && !el.parentNode.classList.contains('lcs_wrap')) ) {
            return false;    
        }
        
        return true;
    };
    
    
    // pure-JS equivalent to parents()
    const recursive_parent = (element, target) => {
        let node = element;
        
        while(node.parentNode != null && !node.matches(target) ) {
            node = node.parentNode;
        }
        return node;
    };
    
})();

//switch script end


jQuery_T4NT(document).ready(function ($) {

	$('#t4s-menu-drawer').on("opendDrawer",function(){

		
		$(".ilyacurswitcher").on("click",function(e){

			document.querySelector('.xcentric-header-geoip').click();
		});

		setTimeout(() => {
  
  $(".ilyacurswitcher").on("click",function(e){

			document.querySelector('.xcentric-header-geoip').click();
		});
}, "400");
	});

//$('.pr-bookable h3.t4s-product-title').sameHeight();
  window.dispatchEvent( new Event('xcentric_scripts_loaded') );

  
  /**
   *  Variant selection changed
   *  data-variant-toggle="{{variant.id}}"
   */
  $(document).on("variant:changed", function (evt) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });
  //open gorgias chat
  //console.log("qweqwe");
  $('a[href="#chat-button"]').click(function (e) {
    e.preventDefault();
    GorgiasChat.open();
   // console.log("asdasd");
   // if (chatcounter == 0)  {GorgiasChat.open(); chatcounter = 1; }
   // else {GorgiasChat.close();chatcounter = 0; }
  });



  //
  // MRSGLAM LINK AT TOP REPLACE
  //
  
});

